import { render } from "./QuestionListItem.vue?vue&type=template&id=3b23fa28&scoped=true"
import script from "./QuestionListItem.vue?vue&type=script&lang=js"
export * from "./QuestionListItem.vue?vue&type=script&lang=js"

import "./QuestionListItem.vue?vue&type=style&index=0&id=3b23fa28&scoped=true&lang=css"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b23fa28"]])

export default __exports__